module.exports = "<footer class=\"app-footer\">\r\n  <span><a href=\"http://coreui.io\"></a>  </span>\r\n  <span class=\"ml-auto\"> <a href=\"http://coreui.io\"></a></span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main